<template>
  <div class="program-page">
    <div v-for="(item, index) in programList" :key="index" class="item-div">
      <p class="item-title" v-html="item.title"></p>

      <div class="second img-left">
<!--        <img :src="imageSrc(item.num)" alt="">-->
        <div class="desc-div">
          <p class="desc">{{item.desc}}</p>
          <ul>
            <li>
              <div><p>활동 시기 :&nbsp;</p></div>
              <div><p>{{item.date}}</p></div>
            </li>
            <li>
              <div><p>활동 장소 :&nbsp;</p></div>
              <div><p>{{item.place}}</p></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocalParticipationEvents',
  data() {
    return {
      programList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.programList = [
        {
          num: 3,
          title: '노란물결 : 지역밀착',
          desc: '“노란물결 : 지역밀착”은 전남드래곤즈가 전라남도 각 지역을 직접 방문하여 축제 및 행사에 참여하고, 지역민과의 현장 접점을 확대함으로써 구단의 지역밀착도를 강화하고 브랜드 인지도를 높이기 위한 지역사회연계 프로그램이다.',
          date: '3월 ~ 11월',
          place: '전라남도',
        },
      ];
    },

    imageSrc(num) {
      return require(`@/assets/img/club/local_0${num}.png`);
    },
  },
};
</script>

<style scoped>
.total-year-records {
  padding-right: 0;
}

.total-year-records table {
  min-width: auto;
}

.program-page .item-div .desc {
  word-break: normal !important;
}

@media (max-width: 959px) {
  .total-year-records table {
    min-width: 800px;
  }
}
</style>
